import { render, staticRenderFns } from "./FrequencyOfUse.vue?vue&type=template&id=cbce0524"
import script from "./FrequencyOfUse.vue?vue&type=script&lang=js"
export * from "./FrequencyOfUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports